import CmClient from './cmClient';

export default class HolderCmClient extends CmClient {
    constructor(id, options) {
        super(id, options, 'HolderCmClient');
    }
}
